import { createFileRoute } from "@tanstack/react-router";
import { StaticInfoPage } from "@/components/static-info-page";
import { BUSINESS_INFO, CONTACT_CHANNEL } from "@/lib/business-info";

const FAQ_SECTIONS = [
  {
    title: "Bói Đê có thay thế chuyên gia không?",
    paragraphs: [
      "Không. Bói Đê cung cấp nội dung tham khảo dựa trên phương pháp huyền học truyền thống và AI, không thay thế tư vấn pháp lý, y tế, tài chính hoặc chuyên môn khác.",
    ],
  },
  {
    title: "Nạp tiền xong nhưng số dư chưa cập nhật thì sao?",
    paragraphs: [
      `Bạn hãy chờ hệ thống ngân hàng và cổng thanh toán xác nhận giao dịch. Nếu quá lâu chưa cập nhật, vui lòng gửi mã giao dịch hoặc thông tin thanh toán qua ${CONTACT_CHANNEL}.`,
    ],
  },
  {
    title: "Tiền đã nạp có được hoàn lại không?",
    paragraphs: [
      "Không. Tiền nạp được quy đổi thành số dư để sử dụng dịch vụ trên Bói Đê và không được hoàn lại, không rút ra tiền mặt, không chuyển nhượng sang tài khoản khác. Vui lòng cân nhắc kỹ trước khi nạp.",
      "Trường hợp duy nhất được cộng bù vào số dư: chuyển khoản thành công nhưng ví chưa được cộng, hoặc một lượt dịch vụ bị trừ phí mà không trả kết quả do lỗi hệ thống. Xem chi tiết tại trang Điều khoản dịch vụ.",
    ],
  },
  {
    title: "Tôi xem lại lịch sử ở đâu?",
    paragraphs: [
      "Bạn có thể vào mục Lịch sử để xem các phiên tham vấn đã tạo. Vào mục Biến động để xem lịch sử nạp tiền và thay đổi số dư.",
    ],
  },
  {
    title: "Dữ liệu cá nhân có được bảo mật không?",
    paragraphs: [
      "Bói Đê áp dụng các biện pháp bảo mật phù hợp để bảo vệ dữ liệu. Bạn cũng nên bảo mật tài khoản, thiết bị và không chia sẻ thông tin đăng nhập.",
    ],
  },
  {
    title: "Làm sao để liên hệ hỗ trợ?",
    paragraphs: [
      `Bạn có thể gửi yêu cầu hỗ trợ qua ${CONTACT_CHANNEL}. Đơn vị vận hành Bói Đê: ${BUSINESS_INFO.name}.`,
    ],
  },
];

export const Route = createFileRoute("/faq")({
  head: () => ({
    meta: [
      { title: "Câu Hỏi Thường Gặp (FAQ) - Tài Khoản, Kinh Dịch, Tử Vi" },
      {
        name: "description",
        content:
          "Giải đáp các thắc mắc phổ biến khi sử dụng Bói Đê: tài khoản, nạp tiền, Kinh Dịch, Tử Vi và bảo mật dữ liệu. Tìm hiểu ngay!",
      },
      { property: "og:title", content: "Câu Hỏi Thường Gặp (FAQ) - Tài Khoản, Kinh Dịch, Tử Vi" },
      {
        property: "og:description",
        content:
          "Tổng hợp câu hỏi thường gặp về tài khoản, thanh toán, Kinh Dịch và Tử Vi tại Bói Đê.",
      },
      { property: "og:url", content: "https://boide.online/faq" },
    ],
    links: [{ rel: "canonical", href: "https://boide.online/faq" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          mainEntity: FAQ_SECTIONS.map((s) => ({
            "@type": "Question",
            name: s.title,
            acceptedAnswer: {
              "@type": "Answer",
              text: s.paragraphs.join(" "),
            },
          })),
        }),
      },
    ],
  }),
  component: FaqPage,
});

function FaqPage() {
  return (
    <StaticInfoPage
      kicker="FAQ"
      title="Câu hỏi thường gặp"
      description="Giải đáp nhanh các thắc mắc phổ biến về tài khoản, nạp tiền, Kinh Dịch, Tử Vi và dữ liệu cá nhân."
      sections={FAQ_SECTIONS}
    />
  );
}
